module.exports = __webpack_public_path__ + "img/album14_26.fe16642c.jpg";